<template>
  <b-col
    md="4"
    class="d-flex mb-3"
  >
    <b-card class="w-100 h-100 product-card">
      <b-row class="align-items-start">
        <b-col
          cols="4"
          class="text-center"
        >
          <img
            :src="activeImageUrl"
            alt="Product"
            class="product-image"
            @click="openPreview(activeImageUrl)"
          >
        </b-col>

        <b-col cols="8">
          <h5 class="mb-1">
            {{ item.name }}
          </h5>
          <p class="mb-1">
            <strong>Marka:</strong> {{ item.product.brand.name }}
          </p>
          <p class="mb-1">
            <strong>Kategori:</strong> {{ item.product.category.name }}
          </p>
        </b-col>
      </b-row>
      <b-row v-if="mediaUrls.length > 1">
        <b-col cols="12">
          <div class="thumb-list mt-50">
            <img
              v-for="(imageUrl, index) in mediaUrls"
              :key="imageUrl"
              :src="imageUrl"
              alt="Product Thumbnail"
              class="thumb-image"
              :class="{ 'is-active': index === activeImageIndex }"
              @click="activeImageIndex = index"
            >
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="12">
          <div class="mb-0">
            <strong>Barkodlar:</strong>
            <div
              v-if="variants.length"
              class="variant-list mt-50"
            >
              <product-variant-item
                v-for="variant in variants"
                :key="variant.id"
                :variant="variant"
                :product="tyProduct(variant)"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-col>

</template>

<script>
import ProductVariantItem from './ProductVariantItem.vue'

export default {
  name: 'Product',
  components: {
    ProductVariantItem,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeImageIndex: 0,
    }
  },
  computed: {
    mediaUrls() {
      if (!Array.isArray(this.item.medias)) {
        return []
      }

      return this.item.medias
        .map(media => this.formatImageUrl(media?.url))
        .filter(Boolean)
    },
    activeImageUrl() {
      return this.mediaUrls[this.activeImageIndex] || this.mediaUrls[0] || ''
    },
    variants() {
      return Array.isArray(this.item.variants) ? this.item.variants : []
    },
  },
  methods: {
    tyProduct(variant) {
      return {
        id: null,
        product_name: this.item.name,
        merchant_sku: variant?.barcode,
        images: [],
      }
    },
    openPreview(imageUrl) {
      this.$emit('open-preview', imageUrl)
    },
    formatImageUrl(url) {
      if (!url) {
        return ''
      }

      const normalizedUrl = url.replace(/\/(\d+)\.jpg$/, '/$1_org_zoom.jpg')
      return `https://cdn.dsmcdn.com/${normalizedUrl}`
    },
  },
}
</script>

<style scoped>
.product-image {
  width: 100%;
  max-width: 220px;
  height: auto;
  object-fit: contain;
  cursor: zoom-in;
}

.thumb-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
}

.thumb-image {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border: 1px solid #d8d6de;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.7;
}

.thumb-image.is-active {
  border-color: #7367f0;
  opacity: 1;
}

.variant-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-card {
  display: flex;
  flex-direction: column;
}
</style>
